export const locale = {
  lang: 'de',
  data: {
    'AVANCES': {
      'GOSURVEY':'Zur Umfrage gehen',
      'GOPORTAL':'Zum Zählportal gehen',
      'REGRESAR':'Zurück',
      'DESCARGAR':'Excel herunterladen',
      'PRIMEROS':'Die ersten 1000 Zeilen holen',
      'SINCRONIZAR':'Mit Zählportal synchronisieren',
      'AGREGAR':'Hinzufügen',
      'PRODUCTO':'Produkt',
      'FEC-LAN': 'Einführungsdatum',
      'FEC-CIE': 'Abschlussdatum',
      'NOFEC-LAN': 'Sie haben noch kein Einführungsdatum festgelegt',
      'FEC-CIE-PROR': 'Abschlussdatum verlängert',
      'CER': 'Umfrage schließen',
      'ABR': 'Umfrage öffnen',
      'SURVEY': 'Umfrage: ',
      'FILE':'Cultura Go Cloud Drive: ',
      'PROR':'UMFRAGE ERWEITERN',
      'WARNING-FECHA-GUARDAR':'Sind Sie sicher, dass Sie datierte Erweiterungen hinzufügen ',
      'SUCCESS-PRORROGA':'Das Abschlussdatum wurde auf ',
      'WARNING-CIERRE-ENCUESTA':'Sind Sie sicher, dass Sie den Status der Umfrage ändern können',
      'SUCCESS-CIERRE': 'Die Umfrage wurde korrekt geändert',
      'PORCENTAJE':'Vorschau der Antworten: ',
      'DES':'Zum Anzeigen anklicken',
      'WARNING-BTN':'Diese Aktion kann nicht abgeschlossen werden, da Ihre Umfrage nicht gestartet wurde',
      'PROCESARRESU': 'Ergebnisse verarbeiten',
      'ETIQUETAS':{
        'ETIQUETAS': 'Artikel pro Seite',
        'OF': 'von',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          'MESSAGE1':'<span>Das Entfernen von Benutzerantworten bestätigen',
          'MESSAGE2':', geben Sie den Benutzernamen in das Textfeld ein</span>',
          'MESSAGE3':'<span>Um das Entfernen der Benutzerantworten zu bestätigen, geben Sie den nächsten Benutzernamen in das Textfeld ein</span>',
          'SALIR': 'Beenden',
          'VALIDAR': 'Benutzer bestätigen',
          'ERRORNOMBREEMPRESA': 'Der Name des eingegebenen Benutzers stimmt nicht mit dem Namen des zu löschenden Benutzers überein',
          'MENSAJE': '¿Sind Sie sicher?¿Sie sind dabei, den Benutzer zu löschen Antworten ',
          'CANCELAR': 'Abbrechen',
          'CONFIRMAR': 'Ja, löschen',
          'SUCCES': 'Die Antworten wurden gelöscht',
          'CERRAR': 'Schließen'
        },
        'MESSAGE':'¿Sind Sie sicher, dass Sie die Antworten des Benutzers ',
        'RESP_SI':'Ja',
        'RESP_NO':'Nein',
        'ACEPTAR':'Akzeptieren',
        'CANCELAR':'Abbrechen',
        'OK':'Ok',
        'SUCCESS-DELETE':'Antworten erfolgreich gelöscht',
        'ERROR-DELETE':'Es ist etwas Falsches passiert',
      },
      'PROCESAR': {
        'OK': 'Der Prozess wurde erfolgreich gestartet',
        'NOTOK': 'Der Prozess konnte nicht gestartet werden. Zuerst müssen Sie die gewünschten Ergebnisse festlegen'
      },
      'INS':{
        'INS1':' von ',
        'INS2':' Mitarbeiter '
      },
      'INICIO':{
        'TITULO':'Umfragestatus nach Benutzer',
        'INSTRUCCIONES':'Auf der linken Seite befindet sich eine Leiste mit den vom Unternehmen gekauften Produkten. Wenn Sie auf eines davon klicken, werden die Kunden nach Jahren angezeigt, bitte wählen Sie eines aus, um die Liste der Benutzer anzuzeigen, die die Umfrage zu diesem Produkt durchführen.'
      },
      'ENCUESTA':{
        'TTITULO':'Verlaufsumfrage nach Benutzer',
        'PRODUCTS':'Eigene Produkte',
        'LABEL01':'Name',
        'LABEL02':'E-Mail',
        'LABEL03':'Umfrageschlüssel',
        'LABEL04':'Status',
        'LABEL05':'Einladung',
        'LABEL06':'Erinnerung',
        'LABEL07':'Löschen',
        'LABEL08':'Start',
        'LABEL09':'Ende',
        'LABEL10':'Benutzeraktionen',
        'LABEL11':'Umfrage-Aktionen',
        'LABEL12':'Zugriffsschlüssel',
        'DESCARGAR':'Downloading, please wait...',
        'BUSCAR':'Suche',
        'TITULOEXCEL':'Umfrage-Status',
        'CARGANDO':'Laden',
        'ACTIVA':'Umfrage nicht aktivieren',
        //, bitte warten... Ihre gesamten Mitwirkenden:
        'PLACE':'Schreiben Sie den Namen des Mitarbeiters, nach dem Sie suchen',
        'ACTIONS':'Spezielle Aktionen',
        'NOUSER':'Suche nicht gefunden',
        'NA':'Nicht verfügbar',
        'ERROR':'Für dieses Produkt gibt es noch keine Umfrage',
        'ERFOLG1':'Einladung gesendet',
        'SUCCESS2':'Erinnerung gesendet',
        'ERROR1':'Es ist etwas Falsches passiert',
      },
      'TITULOS':{
        'NAME':'Name des Teilnehmers',
        'ESTADOS':'Umfrage-Status',
        'FECHA1':'Umfragebeginn',
        'FECHA2':'Umfrage beenden',
        'ESTADOS_ENC':{
          'TITULO':'Wählen Sie eine Option',
          'TODO':'Alles anzeigen',
          'ESTADO1':'Die Umfrage wurde nicht gestartet',
          'ESTADO2':'Der Benutzer wurde eingeloggt',
          'ESTADO3':'Umfrage läuft',
          'ESTADO4':'Umfrage beendet',
          'ESTADO5':'Nicht akzeptiert',
          'ESTADO6':'Ich akzeptiere die Umfrage',
        }
      },
      'COLUMNAS':{
        'email':'E-Mail',
        'end_date':'Enddatum',
        'id_status':'Status',
        'name':'Name',
        'start_date':'Anfangsdatum'
      },
      'ACCIONES_EMAIL':{
        'ACCIONES':'Aktionen zur Umfrage',
        'INFO':'Die nächsten Schritte zeigen Ihnen die Aktionen, die für den Benutzer ',
        'ACC1':'Einladung senden',
        'ACC2':'Erinnerung senden',
        'ACC3':'Umfrageantwort löschen',
      },
      'NEWCOLAB': {
        'TITULO': 'Neuen Teilnehmer zur Umfrage hinzufügen',
        'INST_1': 'Füllen Sie jeden der erforderlichen Datensätze aus, um einen neuen Teilnehmer hinzuzufügen',
        'TITULO_MOD': 'Ändern Sie die Daten des Teilnehmers',
        'INST_1_MOD': 'Sie können Änderungen an jedem der Datensätze des ausgewählten Teilnehmers vornehmen',
        'INST_2': 'Die mit (*) markierten Felder sind erforderlich',
        'WARNING1':'HINWEIS: DER SCHLÜSSEL DIESES MITARBEITERS ',
        'WARNING2':'KANN NICHT GEÄNDERT WERDEN',
        'DATASET_1': 'Datensatz 1',
        'DATASET_2': 'Datensatz 2',
        'DATASET_3': 'Datensatz 3',
        'DATASET_4': 'Datensatz 4',
        'DATASET_5': 'Datensatz 5',
        'DATASET_6': 'Datensatz 6',
        'DATASET_7': 'Datensatz 7',
        'REQUIRED': 'Dieses Feld ist erforderlich',
        'NEXT': 'Weiter',
        'BACK': 'Zurück',
        'SAVE': 'Speichern',
        'ERR_OWNKEY': 'Die eingegebene Mitarbeiternummer ist bereits in der Datenbank gespeichert, versuchen Sie eine andere',
        'ERR_BOSSKEY': 'Die eingegebene Chefnummer ist nicht in der Datenbank gespeichert, versuchen Sie eine andere',
        'ERR_VAL_1': 'Die eingegebenen Daten im Feld: ',
        'ERR_VAL_2': 'Die im Feld: eingegebenen Daten enthalten unzulässige Zeichen oder sind nicht im richtigen Format',
        'GUARDANDO': 'Die Teilnehmerinformationen werden gespeichert, bitte warten',
        'GUARDANDO_GOFLOW': 'Die Informationen werden gespeichert, bitte warten Sie.',
        'SAVE_OK': 'Die Informationen des neuen Teilnehmers wurden korrekt gespeichert',
        'MOD_OK': 'Die Teilnehmerinformationen wurden erfolgreich geändert',
        'FORMULARIO': 'Sie haben das Anmeldeformular noch nicht ausgefüllt, überprüfen Sie, ob Sie alle erforderlichen Felder ausgefüllt haben und versuchen Sie es erneut',
        'ACCIONES': 'Aktionen',
        'VERACT': 'Benutzeraktionen',
        'LOADACT': 'Verfügbare Aktionen laden',
        'NOACT': 'Für diesen Teilnehmer können keine weiteren Aktionen durchgeführt werden',
        'AVAACT': 'Für den Mitwirkenden können folgende Aktionen durchgeführt werden',
        'ACCIONLIST': {
          'modificar': 'Ändern Sie die Informationen des ausgewählten Mitwirkenden',
          'borrar': 'Den ausgewählten Mitarbeiter löschen'
        },
        'DELCOLAB': 'Bestätigen Sie, dass Sie den ausgewählten Mitarbeiter aus diesem Produkt entfernen möchten? Hinweis: Diese Aktion kann nicht rückgängig gemacht werden',
        'DEL_OK': 'Dieser Beteiligte wurde erfolgreich aus dem Produkt entfernt',
        'ERR_EMAIL': 'Die eingegebene E-Mail-Adresse ist bereits in der Datenbank gespeichert, versuchen Sie eine andere',
        'ERR_SAMEKEY': 'Der eingegebene Chef-Schlüssel und der Mitarbeiter-Schlüssel sind gleich, dies ist nicht erlaubt, versuchen Sie einen anderen',
        'RESET_COLAB_SURVE': 'Bestätigen Sie, dass Sie den Zugang zur Umfrage zurücksetzen möchten? ',
        'ACTU_OK': 'Sie wurde korrekt aktualisiert',
      },
      'FORMULARIO_GO_FLOW':{
        'perspective': 'Perspektive',
        'statementID': 'Reaktive ID',
        'dimensionL1': 'Dimension L1',
        'dimensionL2': 'Dimension L2',
        'survey_Score_OverallTI': 'GlobalTI Score Umfrage',
        'company_Country': 'Land Unternehmen',
        'cgo_Product_Name': 'Produktname cgo',
        'company_Name': 'Name des Unternehmens',
        'ranking_Year': 'Jahr des Rankings',
        'survey_Respondents': 'Befragte',
        'survey_Score_Camaraderie': 'Umfrage zum Kameradschaftswert',
        'survey_Score_Credibility': 'Umfrage zum Glaubwürdigkeitsscore',
        'survey_Score_Imparciality': 'Umfrage zu den Unparteilichkeitswerten',
        'survey_Score_Pride': 'Umfrage zu Stolzpunkten',
        'survey_Score_Respect': 'Umfrage zum Thema Respekt',
        'survey_Score_Gestalt': 'Umfrage zum Gestalt-Score',
        'pdf_DateCreation': 'Erstellungsdatum des Zertifikats',
        'WARNI_TI_DA':'Der eingegebene Wert entspricht nicht dem zulässigen Format (100,00)',
        'WARNI_TI_DA_GRAL':'Die eingegebenen Daten entsprechen nicht dem angegebenen Format',
      },
      'FORMULARIO':{
        'fullName': 'FULL NAME',
        'ownKey': 'MITARBEITERNUMMER',
        'age': 'GEBURTSJAHR',
        'surveyKey': 'SURVEY ACCESS KEY',
        'email': 'EMAIL',
        'bossName': 'NAME DES DIREKTEN VORSITZENDEN',
        'bossKey': 'DIRECT BOSS NUMBER',
        'country': 'LAND',
        'location': 'LOCATION',
        'geo_1': 'GEOGRAPHISCHE EBENE 1',
        'geo_2': 'GEOGRAPHISCHE EBENE 2',
        'geo_3': 'GEOGRAPHISCHE EBENE 3',
        'geo_4': 'GEOGRAPHISCHE EBENE 4',
        'geo_5': 'GEOGRAPHISCHE EBENE 5',
        'geo_6': 'GEOGRAPHISCHE EBENE 6',
        'geo_7': 'GEOGRAPHISCHE EBENE 7',
        'geo_8': 'GEOGRAPHISCHE EBENE 8',
        'geo_9': 'GEOGRAPHISCHE EBENE 9',
        'geo_10': 'GEOGRAPHISCHE EBENE 10',
        'geo_19': 'GEOGRAPHISCHE EBENE 19',
        'structure_1': 'STRUKTURENSTUFE 1',
        'structure_2': 'STRUKTURIERUNGSSTUFE 2',
        'structure_3': 'STRUKTURIERUNGSSTUFE 3',
        'structure_4': 'STRUKTURIERUNGSSTUFE 4',
        'structure_5': 'STRUKTURELLE EBENE 5',
        'structure_6': 'STRUKTURIERUNGSSTUFE 6',
        'structure_7': 'STRUKTURIERUNGSSTUFE 7',
        'structure_8': 'STRUKTURIERUNGSSTUFE 8',
        'structure_9': 'STRUKTURIERUNGSSTUFE 9',
        'structure_10': 'STRUKTURIERUNGSSTUFE 10',
        'area': 'AREA',
        'bUnit': 'GESCHÄFTSEINHEIT',
        'eintrittsdatum': 'datum des eintritts in die firma',
        'antiquity': 'ANTIQUITÄT',
        'antiquityUS': 'ANTIQUITY US',
        'generation': 'GENERATION',
        'generationUS': 'GENERATION US',
        'ageUS': 'AGE',
        'charge': 'STELLUNG ODER FUNKTION IM UNTERNEHMEN',
        'homologado': 'STELLUNG ODER FUNKTION ANERKANNT',
        'homologadoUS': 'TÄTIGKEIT ODER FUNKTION ANGENOMMEN US',
        'gender': 'GENDER',
        'genderType': 'TYP DES GESCHLECHTS',
        'typeofwork': 'TYPE OF COMPENSATION',
        'workCondition': 'ARBEITSBEDINGUNG',
        'academico': 'AKADEMISCHER ABSCHLUSS',
        'contratacion': 'VERTRAGSTYP',
        'situacionUS': 'ARBEITSSITUATION US',
        'personal': 'ARBEITGEBER-TYP',
        'jornada': 'ARBEITSZEITRAUM-TYP',
        'rotacion': 'DOES SHIFT ROTATION',
        'phone': 'COLLABORATOR S PHONE',
        'extension': 'DIREKTE ERWEITERUNG DES COLLABORATORS',
        'cellphone': 'KOLLABORATOR S CELLPHONE',
        'native': 'Muttersprache',
        'answer': 'ANTWORT',
        'other_1': 'ANDERE 1',
        'other_2': 'ANDERE 2',
        'other_3': 'ANDERE 3',
        'other_4': 'ANDERE 4',
        'other_5': 'ANDERE 5',
        'other_6': 'ANDERE 6',
        'other_7': 'ANDERE 7',
        'other_8': 'ANDERE 8',
        'other_9': 'ANDERE 9',
        'other_10': 'ANDERE 10',
      },
      'SINCRONIZACION':{
        'SINCRONIZANDO':'Synchronisierung mit Zählportal, bitte warten...',
        'SUCCESS':'Synchronisation korrekt abgeschlossen',

      }
    },
  }
};
